import {ActionReducerMapBuilder, createSlice} from '@reduxjs/toolkit'
import {AnalyticsDownloadState, SliceStatus} from 'interfaces'
import {
  downloadAnalyticsLogs,
  downloadAnalyticsLogsFailure,
  downloadAnalyticsLogsSuccess,
  resetDownloadAnalyticsLogsState,
} from './actions'

const analyticLogDownloadInitialState: AnalyticsDownloadState = {
  status: SliceStatus.idle,
  fileUrl: '',
}

const analyticsLogsDownloadSlice = createSlice({
  name: 'analyticLogsDownload',
  initialState: analyticLogDownloadInitialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<AnalyticsDownloadState>) =>
    builder
      .addCase(downloadAnalyticsLogs, state => ({
        ...state,
        status: SliceStatus.pending,
      }))
      .addCase(downloadAnalyticsLogsSuccess, (state, action) => ({
        ...state,
        status: SliceStatus.resolved,
        fileUrl: action?.payload,
      }))
      .addCase(downloadAnalyticsLogsFailure, state => ({
        ...state,
        status: SliceStatus.rejected,
        fileUrl: '',
      }))
      .addCase(resetDownloadAnalyticsLogsState, () => ({
        ...analyticLogDownloadInitialState,
      }))
      .addDefaultCase(state => state),
})

export const {
  reducer: analyticsLogsDownloadReducer,
  name: analyticsLogsDownloadReducerName,
} = analyticsLogsDownloadSlice
